/** Open a PDF blob in a hidden iframe and trigger the browser print dialog. */
export function printPdfBlob(blob: Blob, filename?: string): void {
  const pdfBlob = blob.type === 'application/pdf' ? blob : new Blob([blob], { type: 'application/pdf' });
  const printName = filename?.trim().replace(/\.pdf$/i, '') || '';
  const namedBlob =
    printName.length > 0
      ? new File([pdfBlob], `${printName}.pdf`, { type: 'application/pdf' })
      : pdfBlob;
  const url = URL.createObjectURL(namedBlob);
  const iframe = document.createElement('iframe');
  iframe.className = 'cn-print-frame';
  iframe.setAttribute('aria-hidden', 'true');
  iframe.title = printName || 'Cover note print';
  iframe.src = url;

  let cleaned = false;
  const previousTitle = document.title;
  const cleanup = () => {
    if (cleaned) return;
    cleaned = true;
    document.title = previousTitle;
    URL.revokeObjectURL(url);
    iframe.remove();
  };

  iframe.onload = () => {
    const win = iframe.contentWindow;
    if (!win) {
      cleanup();
      return;
    }
    if (printName) document.title = printName;
    win.focus();
    win.print();
    win.addEventListener('afterprint', cleanup, { once: true });
    window.setTimeout(cleanup, 60_000);
  };

  document.body.appendChild(iframe);
}
